import { useTemasNotificaciones } from '../contexts/TemasNotificacionesContext';

const obtenerListadoTemasPrincipales = () => {
	const { temasConSubtemasVisibles } = useTemasNotificaciones();

	return temasConSubtemasVisibles;
}

const obtenerListadoTemas = (temaPrincipal) => {
    const { temasConTodosSubtemas } = useTemasNotificaciones();

    const tema = temasConTodosSubtemas.find(tema => tema.id === temaPrincipal.id);
    if (!tema) {
        return [];
    }

    return tema.subtemas;
};

export {
    obtenerListadoTemasPrincipales,
	obtenerListadoTemas
}